export default {
  SET_FIELD_TENANTS: 'setFieldTenants',
  SET_SELECTED_USER: 'setSelectedUser',
  SET_USERS: 'setUsers',
  SET_USER_GROUPS: 'setUserGroups',
  SET_INACTIVE_FILTER_VAL: 'setInactiveFilterVal'
}